<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9" style="max-width: 2000px;">
      <div class="d-flex mb-3 mb-xl-0 flex-column flex-xl-row">
        <div class="mr-3 flex-grow-1" style="min-width: 1px;">
          <!-- Datos del cliente -->
          <div class="card shadow mb-3">
            <div v-if="customer">
              <div class="card-header bg-transparent">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="flex-grow-1">
                    <div class="d-flex align-items-center">
                      <span class="m-0 h3">{{returnRequest.CardName}}
                        <span class="text-muted m-0 h4">{{returnRequest.CardCode}}</span>
                      </span>
                    </div>
                    <h4 class="text-muted m-0 d-flex align-items-center font-weight-normal">
                      <span>Solicitud de Devolución 
                        <span style="letter-spacing: 0.5px;">
                          #{{$route.params.DocNum}}
                        </span>
                      </span>
                      <div class="ml-2" title="Estatus del documento">
                        <badge v-if="returnRequest.DocumentStatus === 'bost_Open'" type="primary">Abierta</badge>
                        <badge v-else-if="returnRequest.CancelStatus === 'csYes'" type="danger">Cancelada</badge>
                        <badge v-else-if="returnRequest.DocumentStatus === 'bost_Close'" type="light">Cerrada</badge>
                      </div>
                      <div v-if="returnRequest.U_ApprovalStatus" class="ml-2" title="Estatus de aprobación">
                        <badge v-if="returnRequest.U_ApprovalStatus === 'P'" type="blue">Pendiente</badge>
                        <badge v-else-if="returnRequest.U_ApprovalStatus === 'R'" type="red">Rechazado</badge>
                        <badge v-else-if="returnRequest.U_ApprovalStatus === 'A'" type="green">Autorizado</badge>
                        <badge v-else-if="returnRequest.U_ApprovalStatus === 'RV'" type="yellow">Revisión</badge>
                      </div>
                    </h4>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="d-flex flex-column flex-xl-row">
                  <div class="d-flex my-1">
                    <h5 class="m-0">RFC</h5>
                    <p class="text-xs pl-2 m-0"><b>{{returnRequest.FederalTaxID}}</b></p>
                  </div>
                  <div class="d-flex my-1 ml-xl-4" v-if="customer.U_TS_RegFiscal && regimenes">
                    <h5 class="m-0">Régimen Fiscal</h5>
                    <p class="text-xs pl-2 m-0"><b>{{regimenes.find(x => x.Code === customer.U_TS_RegFiscal).Name}}</b></p>
                  </div>	
                  <div class="d-flex my-1 ml-xl-4">
                    <h5 class="m-0">Uso CFDI</h5>
                    <p class="text-xs pl-2 m-0"><b>{{ cfdi }}</b></p>
                  </div>
                </div>
              </div>
              </div>
              <div v-else style="height: 700px; padding-top: 300px;">
                <base-loader></base-loader>
              </div>
          </div>
          <!-- Detalles de Solicitud de Devolución -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Detalles de Solicitud de Devolución</h6>
            </div>
            <div class="card-body">
              <div class="container m-0 p-0">
              <div class="row">
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Almacén</h5>
                  <p class="text-xs pl-2 m-0"><b>{{returnRequest.DocumentLines[0].WarehouseCode}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">C. P. de Almacén</h5>
                  <p class="text-xs pl-2 m-0"><b>{{zipCode}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="returnRequest.SalesPersonCode && salesPersonOptions">
                  <h5 class="m-0">Vendedor</h5>
                  <p class="text-xs pl-2 m-0"><b>{{salesPersonOptions.find(x => x.SalesEmployeeCode === returnRequest.SalesPersonCode).SalesEmployeeName}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" >
                  <h5 class="m-0">Contacto</h5>
                  <p class="text-xs pl-2 m-0 text-truncate" v-if="returnRequest.ContactPersonCode && customer">
                    <b>{{customer.ContactEmployees.find(x => x.InternalCode === returnRequest.ContactPersonCode).Name}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Moneda</h5>
                  <p class="text-xs pl-2 m-0"><b>{{returnRequest.DocCurrency}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Fecha contable</h5>
                  <p class="text-xs pl-2 m-0"><b>{{returnRequest.DocDate}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Fecha de entrega</h5>
                  <p class="text-xs pl-2 m-0"><b>{{returnRequest.DocDueDate}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Periodicidad</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.periodicity}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Meses</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.months}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Año</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.year}}</b></p>
                </div>
              </div>
            </div>
            </div>
          </div>
          <!-- Tabla de artículos -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header border-0">
              <h6 class="heading-small text-muted m-0 p-0">Artículos</h6>
            </div>
              <div v-if="docLines" class="table-responsive">
                <base-table thead-classes="thead-light" :data="docLines">
                <template #columns>
                  <th width="5%">#</th>
                  <th width="35%" class="pl-5">Artículo</th>
                  <th width="10%" class="text-center">Pedimento</th>
                  <th width="10%" class="text-right">Rollos</th>
                  <th width="10%" class="text-right">Cantidad</th>
                  <th width="10%">U. medida</th>
                  <th width="10%" class="text-right">Precio Unitario</th>
                  <th width="10%" class="text-right">Total</th>
                </template>
                <template #default="{ row }">
                  <td scope="row" width="5%">
                    {{ row["ReturnRequest/DocumentLines"].LineNum + 1}}
                  </td>
                  <td scope="row" width="40%" class="pl-5">
                    <b> {{ row["ReturnRequest/DocumentLines"].ItemCode }} </b>
                    {{ row["ReturnRequest/DocumentLines"].ItemDescription }}
                    <br>
                    <b class="text-primary">{{ row["ReturnRequest/DocumentLines"].U_SubCode }} </b>
                    <span class="text-primary">{{ row["ReturnRequest/DocumentLines"].U_SubDescription }}</span>
                  </td>
                  <td scope="row" width="10%" class="text-center">
                    <span v-if="row['ReturnRequest/DocumentLines'].U_PedimentNum">
                      {{ row['ReturnRequest/DocumentLines'].U_PedimentNum }}
                    </span>
                    <base-input 
                      v-else-if="row.Items.U_Import === 'Y' && returnRequest.DocumentStatus === 'bost_Open'"
                      v-model="row.U_PedimentNum" 
                      inputClasses="input-group-alternative form-control-sm text-xs" 
                      placeholder="Num. Pedimento"
                      class="m-0" 
                      style="width: 170px;" 
                      maxlength="15" 
                      minlength="15">
                    </base-input>
                    <span v-else>-</span>
                  </td>
                  <td scope="row" width="10%" class="text-right">
                    {{ row["ReturnRequest/DocumentLines"].U_Rolls }}
                  </td>
                  <td scope="row" width="10%" class="text-right">
                    {{ row["ReturnRequest/DocumentLines"].Quantity }}
                  </td>
                  <td scope="row" width="10%">
                    {{ row["ReturnRequest/DocumentLines"].MeasureUnit }}
                  </td>
                  <td scope="row" width="10%" class="text-right">
                    {{ currencyFormat(row["ReturnRequest/DocumentLines"].UnitPrice, currency.iso) }}
                  </td>
                  <td scope="row" width="10%" class="text-right">
                    {{ currencyFormat(currency.iso === 'MXN' ? row["ReturnRequest/DocumentLines"].RowTotalSC : row["ReturnRequest/DocumentLines"].RowTotalFC, currency.iso) }}
                  </td>
                </template>
                </base-table>
              </div>
              <div class="d-flex justify-content-end px-4 border-top py-2">
                <table class="text-right text-sm">
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Subtotal</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? returnRequest.DocTotalSys - returnRequest.VatSumSys : returnRequest.DocTotalFc - returnRequest.VatSumFc, currency.iso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">IVA</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? returnRequest.VatSumSys : returnRequest.VatSumFc, currency.iso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Total</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? returnRequest.DocTotalSys : returnRequest.DocTotalFc, currency.iso) }}
                    </td>
                  </tr>
                </table>
              </div>
          </div>
          <!-- Datos Adicionales -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Datos adicionales</h6>
            </div>
            <div class="card-body">
              <div class="container m-0 p-0">
                <div class="row">
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5 class="m-0">Referencia</h5>
                  <p class="text-xs ml-2"><b>{{returnRequest.NumAtCard}}</b></p>
                </div>
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5>Comentarios</h5>
                  <p class="text-xs ml-2"><b>{{returnRequest.Comments}}</b></p>
                </div>
                </div>
              </div>
              <div class="mb-3 border-top pt-3">
                <div class="align-items-center">
                  <div class="row">
                    <div class="col-4">
                      <h5 class="mb-1">Razón de devolución *</h5>
                      <multiselect 
                        v-model="selReasonReturn" 
                        placeholder="Razón de devolución"
                        :options="reasons ? reasons : []" 
                        class="mb-4 small-multiselect" 
                        label="Description" 
                        track-by="Value"
                        :allow-empty="false"
                        :loading="!reasons" 
                        :disabled="!reasons || !['P', null, 'R'].includes(returnRequest.U_ApprovalStatus)" 
                        :show-labels="false">
                        >
                      </multiselect>
                    </div>

                    <div class="col-4">
                      <h5 class="mb-1">Tipo de Factura *</h5>
                      <multiselect
                        v-model="selInvType"
                        placeholder="Tipo de Factura" 
                        :options="invTypes" 
                        class="mb-4 small-multiselect"
                        label="name" 
                        track-by="id"
                        :options-limit="30"
                        @select="({id}) => loadInvoices(id)" 
                        :show-labels="false"
                        :allow-empty="false"
                        :disabled="!invoices || !['P', null, 'R'].includes(returnRequest.U_ApprovalStatus)" 
                      />
                    </div>

                    <div class="col-4">
                      <h5 class="mb-1">Factura(s) *</h5>
                      <multiselect
                        v-model="selInvoices"
                        placeholder="Factura(s)" 
                        :options="invoices ? invoices : []" 
                        class="mb-4 small-multiselect"
                        :custom-label="invoice => `#${invoice.DocNum} - ${invoice.DocCur !== 'MXP' ? `$${invoice.DocTotalFC - invoice.PaidSumFc}` : `$${invoice.DocTotal - invoice.PaidSum}`}`"
                        track-by="DocNum"
                        :loading="!invoices || selectingInvoice" 
                        :disabled="
                          !invoices || 
                          selectingInvoice || 
                          (
                            !['P', null, 'R'].includes(returnRequest.U_ApprovalStatus) &&
                            !(returnRequest.U_ApprovalStatus === 'A' && (!selInvoices || selInvoices.length === 0))
                          )
                        "
                        :options-limit="30"
                        @select="onSelectInvoice" 
                        @remove="onRemoveInvoice"
                        :show-labels="false"
                        multiple>
                      </multiselect>
                    </div>
                    <div class="col-4">
                      <h5 class="mb-1">Tipo de referencia *</h5>
                      <multiselect 
                        v-model="refTypeSelected" 
                        placeholder="Tipo de referencia"
                        :options="refType ? refType : []" 
                        class="mb-4 small-multiselect" 
                        :custom-label="x => {return `${x.Value} - ${x.Description}`}"
                        track-by="Value"
                        :loading="!refType" 
                        :disabled="
                          !refType || 
                          (
                            !['P', null, 'R'].includes(returnRequest.U_ApprovalStatus) &&
                            !(returnRequest.U_ApprovalStatus === 'A' && !refTypeSelected)
                          )
                        " 
                        :show-labels="false">
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-side-cards">
          <!-- Crear Nota de Crédito a -->
          <div class="card shadow mb-3">
            <div v-if="customer">
              <div class="card-header py-3">
                <h6 class="heading-small text-muted m-0">Crear Nota de Crédito a:</h6>
              </div>
              <div class="card-body py-2">
                <div class="d-flex mb-1 ">
                  <i class="fas fa-map-marker-alt mr-2 pt-1 text-gray"></i>
                  <div class="text-xs m-0 font-weight-bold text-default">
                    <span>{{returnRequest.AddressExtension.BillToStreet}} </span>
                    <span>{{returnRequest.AddressExtension.BillToStreetNo}} </span>
                    <span>{{returnRequest.AddressExtension.BillToBlock}}</span>
                    <br>
                    <span>{{returnRequest.AddressExtension.BillToZipCode}} </span>
                    <span>{{returnRequest.AddressExtension.BillToCity}} </span>
                    <span>{{returnRequest.AddressExtension.BillToState}}</span>
                    <br>
                    <span>{{returnRequest.AddressExtension.BillToCountry}}</span>
                  </div>
                </div>
                <hr class="my-2">
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0 flex-shrink-0">Vía de Pago *</h5>
                  <span class="text-xs m-0 ml-2 flex-grow-1">
                    <multiselect 
                      v-model="selPaymentMethod"
                      :options="paymentMethods || []"
                      placeholder="Seleccionar vía de pago"
                      class="small-multiselect"
                      label="description"
                      track-by="value"
                      :show-labels="false"
                      :allow-empty="false"
                      :disabled="!['P', null, 'R'].includes(returnRequest.U_ApprovalStatus)"
                    />
                  </span>
                </div>

                <div class="d-flex align-items-center mb-1" v-if="selPaymentMethod">
                  <h5 class="m-0">Método de Pago</h5>
                  <span class="text-xs m-0 ml-2">
                    {{selPaymentMethod.value === '99' ? 'PPD' : 'PUE'}}
                  </span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Condiciones de Pago</h5>
                  <span class="text-xs m-0 ml-2">
                    {{paymentGroup.name}}
                  </span>
                </div>
              </div>
            </div>
            <div v-else class="py-6">
              <base-loader></base-loader>
            </div>
          </div>
          <!-- Enviar a -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Enviar a:</h6>
            </div>
            <div class="card-body py-2">
              <div class="d-flex mb-1">
                <i class="fas fa-map-marker-alt mr-2 pt-1 text-gray"></i>
                <div class="text-xs m-0 font-weight-bold text-default">
                  <span>{{returnRequest.AddressExtension.ShipToStreet}} </span>
                  <span>{{returnRequest.AddressExtension.ShipToStreetNo}} </span>
                  <span>{{returnRequest.AddressExtension.ShipToBlock}}</span>
                  <br>
                  <span>{{returnRequest.AddressExtension.ShipToZipCode}} </span>
                  <span>{{returnRequest.AddressExtension.ShipToCity}} </span>
                  <span>{{returnRequest.AddressExtension.ShipToState}}</span>
                  <br>
                  <span>{{returnRequest.AddressExtension.ShipToCountry}}</span>
                </div>
              </div>
              <hr class="my-2">
              <div class="d-flex align-items-center mb-1">
                <h5 class="m-0">Método de envío</h5>
                <span v-if="shippingMethod" class="text-xs m-0 ml-2">
                  {{shippingMethod.Description}}
                </span>
              </div>
              <div class="d-flex align-items-center mb-1">
                <h5 class="m-0">Pago flete</h5>
                <span v-if="freightPayment" class="text-xs m-0 ml-2">
                  {{freightPayment.Description}}
                </span>
              </div>
            </div>
          </div>
          <!-- Timbrado -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Timbrado</h6>
            </div>
            <div class="card-body py-2">
              <div class="d-flex my-1 text-xs">
                  <base-checkbox v-model="stamp">
                    Timbrar ante el SAT
                  </base-checkbox>
              </div>
            </div>
          </div>
          <!-- Boton de Crear Nota de Crédito -->
          <div v-if="customer">
            <div v-if="creating || requesting || handlingRequest" class="flex justify-items-center w-100">
              <base-loader v-if="creating" text="Creando Nota de Crédito. Espere un momento..."></base-loader>
              <base-loader v-else-if="requesting" text="Solicitando. Espere un momento..."></base-loader>
              <base-loader v-else-if="handlingRequest" text="Actualizando. Espere un momento..."></base-loader>
            </div>

            <div v-else>
              <div 
                v-if="
                  !handlingRequest && returnRequest.U_ApprovalStatus === 'RV' && 
                  approvalEmails.includes(user.email)
                " 
                class="d-flex justify-content-between align-items-center">
                <base-button 
                  @click="approveOrReject('A')"
                  block 
                  icon="fa fa-check" 
                  type="success" 
                  class="m-0 mr-2"
                >
                  Aprobar
                </base-button>
                <base-button 
                  @click="approveOrReject('R')"
                  block 
                  icon="fa fa-times" 
                  type="danger" 
                  class="m-0 ml-2"
                >
                  Rechazar
                </base-button>
              </div>

              <div
                v-else-if="
                  !requesting && 
                  ['P', null, 'R'].includes(returnRequest.U_ApprovalStatus) &&
                  !(approvalEmails.includes(user.email) )
                "
                v-b-popover.hover.focus.bottom.html="popoverData"
              >
      
                <base-button
                  @click="authRequest()"
                  icon="fa fa-user-lock" 
                  type="success"
                  block
                  :disabled="!validation.valid"
                >
                  Solicitar autorización
                </base-button>
              </div>

              <div 
                v-else-if="
                  !creating && 
                  returnRequest.DocumentStatus === 'bost_Open' && 
                  returnRequest.U_ApprovalStatus === 'A'
                " 
                v-b-popover.hover.focus.bottom.html="popoverData"
              >
                <base-button 
                  @click="createCreditNote();"
                  block
                  icon="fas fa-check"
                  :disabled="!validation.valid"
                >
                  Crear Nota de Crédito
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import BaseLoader from '@/components/BaseLoader.vue';
import moment from "moment";
import { getAuth } from "firebase/auth";
import Multiselect from 'vue-multiselect'
import currency from '@/data/currency.json';
import posthog from 'posthog-js';
import paymentMethods from '@/data/paymentMethods.json';
import Formats from "@/mixins/Formats";

export default {
  mixins: [Formats],
  components: {
    BaseLoader,
    Multiselect
  },
  data() {
    return {
      HANA_URL: process.env.VUE_APP_HANA_URL,
      user: null,
      docLines: [],
      returnRequest: null,
      customer: null,
      globalInformation: null,
      zipCode: null,
      cfdi: null,
      paymentGroup: {id: 8, name: "Contado"},
      regimenes: null,
      salesPersonOptions: null,
      facturoporti: null,
      creating: false,
      invoices: null,
      selInvoices: [],
      reportIds: [],
      reasons: null,
      selReasonReturn: null,
      selectingInvoice: false,
      currency: null,
      refType: null,
      refTypeSelected: null,
      production: process.env.NODE_ENV === 'production',
      approvalEmails: null,
      requesting: false,
      handlingRequest: false,
      stamp: true,
      selPaymentMethod: null,
      paymentMethods: paymentMethods.filter(x => ['02', '03', '15', '30'].includes(x.value)),
      errorReportIds: [],
      credNotePermission: false,
      selInvType: null,
      invTypes: [
        { id: 'FA', name: 'Factura de cliente', elTypeId: 'INV'},
        { id: 'FAT', name: 'Factura anticipo', elTypeId: 'DPI'}
      ],
      shippingMethod: null,
      freightPayment: null,
    }
  },
  methods: {
    onRemoveInvoice(invoice){
      const index = this.reportIds.indexOf(invoice.DocNum);
      this.reportIds.splice(index, 1);
    }, 
    onSelectInvoice(invoice) { // Error: U_TS_ReportID: 'Error: Ver en descripción.'
      this.selectingInvoice = true;
      axios
        .post(
          `api/fiscal/electronic_docs`, 
          { document_type: this.selInvType.elTypeId, doc_entry: invoice.DocEntry }
        )
        .then(res => {
          // console.log("res reportIDS", res)
          if (res.data[0].U_TS_ReportID) {
            this.reportIds.push(res.data[0].U_TS_ReportID);
          } else {
            this.$swal(`Factura #${invoice.DocNum}`, 'Esta factura no ha sido timbrada.', 'warning')
            const index = this.selInvoices.findIndex(x => {
              return x.DocNum === invoice.DocNum;
            });
            this.selInvoices.splice(index, 1);
          }
        })
        .catch(err => {
          console.error(err);
          this.selInvoices = null;
        }).finally(() => {
          this.selectingInvoice = false;
        });
    },
    authRequest(){
      this.$swal({
        title: `Solicitar autorización`,
        text: "Estás a punto de solicitar la autorización de éste documento, ¿deseas continuar?",
        icon: "question",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.requesting = true;
          
          const jsonStatus = {
            U_ApprovalStatus: "RV",
            U_ApprovalRequestedBy: this.user.email,
            U_ReasonForReturn: this.selReasonReturn.Value,
            PaymentMethod: this.selPaymentMethod.value,
            U_WebRefType: this.refTypeSelected.Value,
            U_WebRefObj: this.selInvType.id,
            U_WebRefDocNum: this.selInvoices.map(x => x.DocNum).join(","),
          }
          
          console.log("JSON", jsonStatus)
          
          axios.patch(`/api/returnRequest/approval_status?DocEntry=${this.returnRequest.DocEntry}`, jsonStatus)
          .then(res => {
            console.log("🟦 PATCH APPROVAL STATUS", res)
            if(res.data.msg && res.data.msg === "Approval_status is updated."){
              
              const json = {
                "to": this.approvalEmails,
                "replyTo": this.user.email,
                "subject": `[Autorización] Solicitud de devolución ${this.returnRequest.DocNum} - ${this.returnRequest.CardName}`,
                "email_body": `
                  <b>Hola, ${this.user.displayName} ha solicitado una aprobación en una solicitud de devolución:</b>
                  <hr>
                  <b>Número: </b>${this.returnRequest.DocNum}<br>
                  <b>Cliente: </b>${this.returnRequest.CardName}<br>
                  <b>Monto: </b> ${new Intl.NumberFormat('mx-MX', { style: 'currency', currency: this.currency.iso })
                  .format(this.returnRequest.DocTotal)}<br>
                  ${this.selReasonReturn ? `<b>Razón de devolución: </b>${this.selReasonReturn.Description}<br>` : ''}
                  Puedes revisar esta solicitud desde la <a href="https://consola.canplast.net/returnRequest/${this.returnRequest.DocNum}"> Consola de Administración </a>
                `
              };

              console.log("JSON to EMAIL", json)

              axios.post('/api/sg/email/send/general', json)
              .then((result) => {
                if(result.data.status_code === 202){
                  this.$swal("Solicitud de autorización enviada", "Tu solicitud esta en proceso de revisión. Por favor, espera a que sea aprobada.", "success");
                  this.loadReturnRequest();
                } else {
                  this.$swal("Correo no enviado", "Solicitud de devolución actualizada. No se pudo enviar el correo.", "warning");
                  console.error("Error", result.data);
                  this.loadReturnRequest();
                } 
              }).catch((error) => {
                this.$swal("Correo no enviado", "Solicitud de devolución actualizada. No se pudo enviar el correo.", "warning");
                console.error("Error", error);
                this.loadReturnRequest();
              }).finally(() => {
                this.requesting = false;
              });
            } else if(res.data.se_err && res.data.se_err.error){
              this.$swal('Error',res.data.se_err.error.message.value, 'error')
              this.requesting = false;
            } else {
              this.$swal('Error', 'Algo salió mal', 'error');
              console.error("Error", res.data)
              this.requesting = false;
            }
          })
          .catch(err => {
            console.error("Error", err)
            this.requesting = false;
          });
        }
      });
    },
    approveOrReject(status){
      const statusName = status === 'A' ? 'Aprobar' : 'Rechazar';
      const statusName2 = status === 'A' ? 'Aprobada' : 'Rechazada';
      this.$swal({
        title: `${statusName} solicitud`,
        text: `Estás a punto de ${statusName.toLowerCase()} la solicitud de devolución, ¿deseas continuar?`,
        icon: "question",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
      }).then((result) => {
        if(result.isConfirmed){
          this.handlingRequest = true;
          axios.patch(
            `api/returnRequest/approval_status?DocEntry=${this.returnRequest.DocEntry}`, 
            { U_ApprovalStatus: status }
          ).then(res => {
            console.log("🟦 Approve or Reject", res)
            if(res.data.msg && res.data.msg === "Approval_status is updated."){
              
              const json = {
                "to": [this.returnRequest.U_ApprovalRequestedBy],
                "replyTo": this.user.email,
                "subject": `[Autorización ${statusName2}] Solicitud de devolución ${this.returnRequest.DocNum} - ${this.returnRequest.CardName}`,
                "email_body": `<b>Hola. Tu solicitud de devolución ha sido ${statusName2} por ${this.user.displayName}</b><hr>
                  <b>Número: </b>${this.returnRequest.DocNum}<br>
                  <b>Cliente: </b>${this.returnRequest.CardName}<br>
                  Puedes revisar esta solicitud desde la <a href="https://consola.canplast.net/returnRequest/${this.returnRequest.DocNum}"> Consola de Administración </a>`
              };

              console.log("JSON to EMAIL", json)

              axios.post('/api/sg/email/send/general', json)
              .then((result) => {
                if(result.data.status_code === 202){
                  this.$swal(`Solicitud ${statusName2.toLowerCase()}`, `La solicitud ha sido actualizada correctamente.`, "success");
                  this.loadReturnRequest();
                } else if (result.data.err && result.data.err.errors) {
                  this.$swal("Error", result.data.err.errors[0].message, "error");
                  console.error("Error", result.data);
                } else {
                  this.$swal(`Solicitud ${statusName2.toLowerCase()}`, 
                  "Solicitud actualizada correctamente. No se pudo enviar el correo", 
                  "warning");
                  console.error("Error", result.data);
                } 
              }).catch((error) => {
                this.$swal(`Solicitud ${statusName2.toLowerCase()}`, 
                  "Solicitud actualizada correctamente. No se pudo enviar el correo", 
                  "warning");
                console.error("Error", error);
              }).finally(() => {
                this.handlingRequest = false;
              });

            } else if(res.data.se_err && res.data.se_err.error) {
              this.$swal('Error', res.data.se_err.error.message.value, 'error')
              this.handlingRequest = false;
            } else {
              this.$swal("Error", "Algo salió mal", "error");
              console.error("Error", res.data)
              this.handlingRequest = false;
            }
          }).catch(err => {
            this.$swal("Error", "Algo salió mal", "error");
            console.error("Error", err)
            this.handlingRequest = false;
          });

        }
      })
    },
    createCreditNote() {
      this.creating = true;
      let items = this.docLines.map(item => {
        let subTotal = (item['ReturnRequest/DocumentLines'].UnitPrice * item['ReturnRequest/DocumentLines'].Quantity);
        let linea = {
          ProductCode: item.NCMCodesSetup.NCMCode,
          IdentificationNumber: item['ReturnRequest/DocumentLines'].U_SubCode ? item['ReturnRequest/DocumentLines'].U_SubCode : item['ReturnRequest/DocumentLines'].ItemCode,
          Description: item['ReturnRequest/DocumentLines'].U_SubDescription ? item['ReturnRequest/DocumentLines'].U_SubDescription : item['ReturnRequest/DocumentLines'].ItemDescription,
          UnitCode: item['ReturnRequest/DocumentLines'].UoMCode,
          UnitPrice: item['ReturnRequest/DocumentLines'].UnitPrice,
          Quantity: item['ReturnRequest/DocumentLines'].Quantity,
          Subtotal: subTotal.toFixed(6),
          TaxObject: item['ReturnRequest/DocumentLines'].U_TS_ObjetoImpFact,
          Total: ['01','03','04','05'].includes(item['ReturnRequest/DocumentLines'].U_TS_ObjetoImpFact) ? subTotal.toFixed(6) : (subTotal * 1.16).toFixed(6),
        };
        if(!['01','03','04','05'].includes(item['ReturnRequest/DocumentLines'].U_TS_ObjetoImpFact)){
          linea.Taxes = [
            {
              "Total": (subTotal * 0.16).toFixed(6),
              "Name": "IVA",
              "Base": subTotal.toFixed(6),
              "Rate": 0.16,
              "IsRetention": false
            }
          ]
        }
        if (item.Items.ManageBatchNumbers === 'tYES' && item.Items.ManageSerialNumbers === 'tNO'){
          linea.NumerosPedimento = null
        }else if (item['ReturnRequest/DocumentLines'].U_PedimentNum) {
          linea.NumerosPedimento = [item['ReturnRequest/DocumentLines'].U_PedimentNum];
        } else if (item.Items.U_Import === 'Y' && item.U_PedimentNum) {
          linea.NumerosPedimento = [item.U_PedimentNum.replace(/(\d{2})(\d{2})(\d{4})(\d{7})/, "$1  $2  $3  $4")];
        } else {
          // linea.NumerosPedimento = null
        }
        return linea;
      });

      this.facturoporti = {
        "CfdiType": "E",
        "PaymentForm": this.selPaymentMethod.value,
        "PaymentMethod": this.selPaymentMethod.value === '99' ? 'PPD' : 'PUE',
        "ExpeditionPlace": this.zipCode,
        "Date": moment().format('YYYY-MM-DD'),
        "PaymentConditions": this.paymentGroup.name,
        "Exportation": this.returnRequest.U_TS_Exportacion,
        "Receiver": {
          "Rfc": this.customer.FederalTaxID,
          "CfdiUse": this.cfdi,
          "Name": this.customer.CardName,
          "FiscalRegime": this.customer.U_TS_RegFiscal,
          "TaxZipCode": this.returnRequest.AddressExtension.BillToZipCode
        },
        "Items": items,
        "GlobalInformation": this.globalInformation ? this.globalInformation : null,
        "cfdIsRelacionadosLista": 
          this.reportIds.map(uuid => {
            return { 
              "cfdIsRelacionados": uuid,
              "tipoRelacion": this.refTypeSelected.Value
            }
          })
        
        /* "Relations": {
          "Type": "07",
          "Cfdis": this.reportIds.map(uuid => {
            return { "Uuid": uuid }
          })
        }, */
      }
      
      if (this.returnRequest.DocCurrency !== 'MXP') {
        let date = moment().format('YYYYMMDD');
        axios.get(`/api/getCurrencies?date=${date}`)
          .then(res => {
            this.facturoporti.CurrencyExchangeRate = res.data[this.returnRequest.DocCurrency];
            this.facturoporti.Currency = this.returnRequest.DocCurrency;
            this.sap();
          })
          .catch(err => {
            console.error(err);
            this.creating = false;
          });
      } else {
        this.sap();
      }
    },
    sap() {
      let documentLines = this.docLines.map((item) => {
        let pedimento;
        if (item['ReturnRequest/DocumentLines'].U_PedimentNum) {
          pedimento = item['ReturnRequest/DocumentLines'].U_PedimentNum;
        } else if (item.Items.U_Import === 'Y' && item.U_PedimentNum) {
          pedimento = item.U_PedimentNum.replace(/(\d{2})(\d{2})(\d{4})(\d{7})/, "$1  $2  $3  $4");
        } else {
          pedimento = null
        }
        return {
          ItemCode: item["ReturnRequest/DocumentLines"].ItemCode,
          Quantity: item["ReturnRequest/DocumentLines"].Quantity,
          BaseType: 234000031,
          BaseEntry: this.returnRequest.DocEntry,
          BaseLine: item["ReturnRequest/DocumentLines"].LineNum,
          Price: item["ReturnRequest/DocumentLines"].Price,
          U_SubCode: item["ReturnRequest/DocumentLines"].U_SubCode,
          U_SubDescription: item["ReturnRequest/DocumentLines"].U_SubDescription,
          U_PedimentNum: pedimento,
          Currency: this.returnRequest.DocCurrency,
          ... pedimento && {
            BatchNumbers: [{ 
              BatchNumber: pedimento, 
              Quantity: item["ReturnRequest/DocumentLines"].Quantity
            }]
          }
        }
      });

      let sap = {
        "CardCode": this.returnRequest.CardCode,
        "DocCurrency": this.returnRequest.DocCurrency,
        "PaymentMethod": this.selPaymentMethod.value,
        "PaymentGroupCode": this.paymentGroup.id,
        "U_TS_ActStatus": "N",
        "U_TS_GenType": "N",
        "U_TS_DEQ": null,
        "BaseEntry": this.returnRequest.DocEntry,
        "DocumentLines": documentLines,
        "U_WebUser": this.user.email,
        "U_Web": "Y",
        "U_ReasonForReturn": this.selReasonReturn.Value,
        "U_WebRefType":this.refTypeSelected.Value,
        "U_WebRefObj": this.selInvType.id,
        "U_WebRefDocNum": this.selInvoices.map(x => x.DocNum).join(","),
        "U_ApprovalStatus": this.returnRequest.U_ApprovalStatus,
        "U_WebTimbrado": this.stamp ? "Y" : "N",
        "DocumentReferences": this.selInvoices.map(x => ({
          "RefDocEntr": x.DocEntry,
          "RefDocNum": x.DocNum,
          "RefObjType": "rot_SalesInvoice"
        }))
      };
      
      let emails;
      if(process.env.NODE_ENV === 'production'){
        emails = this.customer.ContactEmployees
        .filter((contacto) => contacto.U_TS_EnvioCorreo === "SI" && contacto.E_Mail)
        .map((contacto) => contacto.E_Mail);
      } else {
        emails = [this.user.email];
      }

      if(this.customer.FederalTaxID === 'XEXX010101000'){
        this.facturoporti.Receiver.TaxRegistrationNumber = this.customer.UnifiedFederalTaxID; 
      }
      
      let body = {
        facturoporti: this.facturoporti,
        sap,
        emails,
        type: "nota_credito",
        timbrado: this.stamp,
      };
      console.log("🟩 JSON to CREDIT NOTE", body)

      axios.post(`api/fpt/invoice`, body)
      .then(res => {
        console.log("🟦 CREDIT NOTE RESPONSE", res);
        if(res.data.DocNum){
          this.$swal("Nota de Crédito creada", `La Nota de Crédito #${res.data.DocNum} ha sido creada`, "success")
          .then(() => {
            this.$router.push(`/creditNote/${res.data.DocNum}`);
          });
        } else {
          if(process.env.NODE_ENV === 'production'){
            posthog.capture('ReturnRequestError', res);
          }
          if(res.data.msg){
            this.$swal("Error", res.data.msg, "error");
            this.loadReturnRequest();
          } else if(res.data.error){
            if(res.data.error.error){
              this.$swal("Error", res.data.error.error.message.value, "error")
            } else if(res.data.error.Message){
              this.$swal("Error", res.data.error.Message, "error")
            } else {
              this.$swal('Error', "Algo salió mal, por favor antes de reintentar, verifica si fue creado correctamente y da aviso a soporte", 'error');
              console.error("Error", res);
            }
          } else {
            this.$swal('Error', "Algo salió mal, por favor antes de reintentar, verifica si fue creado correctamente y da aviso a soporte", 'error');
            console.error("Error", res);
          }
        }
      }).catch(err => {
        this.$swal('Error', "Algo salió mal, por favor antes de reintentar, verifica si fue creado correctamente y da aviso a soporte", 'error');
        console.error(err); 
      }).finally(() => {
        this.creating = false;
      });
    },
    loadReturnRequest(){
      axios.get(`/api/returnRequest/getReturnRequest?DocNum=${this.$route.params.DocNum}`)
      .then(res => {
        this.returnRequest = res.data.value[0];
        console.log("RETURN REQUEST", this.returnRequest);
        this.cfdi = this.returnRequest.U_TS_UsoCFDI40
        this.currency = currency.find(x => x.key === this.returnRequest.DocCurrency);
        this.selPaymentMethod = this.paymentMethods.find(x => x.value === this.returnRequest.PaymentMethod) || null;
        this.loadInvoices(this.returnRequest.U_WebRefObj);

        if(this.returnRequest.U_ApprovalRequestedBy === 'darinkahernandez@canplast.com.mx' || this.returnRequest.U_ApprovalRequestedBy === 'dannasandoval@canplast.com.mx'){
          this.approvalEmails = [
            'ofelialujan@canplast.com.mx',
            'lizethflores@canplast.com.mx'
          ];
        }

        if(this.returnRequest.DocumentStatus === 'bost_Open'){
          let query = {
            select: "*",
            table: "@USTI",
            where: `WHERE "U_Email" = '${this.user.email}'`
          };
          
          axios.post(`${this.HANA_URL}/api/hana/basic_general_query`, query)
          .then(res => {
            if(res.data && res.data.length){
              const userWhse = res.data[0].U_Warehouse.split(",");
              const returnRequestWhse = this.returnRequest.DocumentLines[0].WarehouseCode;
              if(
                ["NC","FA_NC"].includes(res.data[0].U_DocumentType) && 
                userWhse.includes(returnRequestWhse)
              ){
                this.credNotePermission = true;
              }
            }
          }).catch(err => {
            console.error(err); 
          });
        }

        axios.get(`/api/user_fields/ReasonForReturn`)
        .then((res) => {
          this.reasons = res.data.value[0].ValidValuesMD;
          this.selReasonReturn = this.reasons.find(x => x.Value === this.returnRequest.U_ReasonForReturn);
        }).catch((err) => {
          console.error(err);
        });

        axios.get(`/api/warehouses/${this.returnRequest.DocumentLines[0].WarehouseCode}`)
          .then(res => {
            this.zipCode = res.data.value[0].ZipCode
          }).catch(err => {
            console.error(err);
          });

        axios.get(`/api/business_partners?card_code=${this.returnRequest.CardCode}`)
          .then(res => {
            this.customer = res.data;
            // console.log("CUSTOMER", this.customer)

            if (this.customer.FederalTaxID === "XAXX010101000") {
              this.globalInformation = {
                periodicity: "01",
                months: moment().format('MM'),
                year: moment().format('YYYY')
              }
            }

          }).catch(err => {
            console.error(err);
          });

        axios.get(`/api/returnRequest/getDocumentLinesByReturnRequest?DocNum=${this.$route.params.DocNum}`)
          .then(res => {
            res.data.value.map((item) => {
              const line = this.returnRequest.DocumentLines.find(x => x.LineNum === item['ReturnRequest/DocumentLines'].LineNum);
              item["ReturnRequest/DocumentLines"].RowTotalFC = line.RowTotalFC;
              item["ReturnRequest/DocumentLines"].RowTotalSC = line.RowTotalSC;
            });
            this.docLines = res.data.value;

          }).catch(error => {
            console.error(error);
          });

          axios.get(`/api/user_fields/WebRefType`)
          .then((res) => {
            this.refType = res.data.value[0].ValidValuesMD;
            this.refTypeSelected = this.refType.find(x => x.Value === this.returnRequest.U_WebRefType) || null;
          }).catch((err) => {
            console.error(err);
          });

        axios.get(`api/user_fields/ShippingMethod`)
        .then(res => {
          this.shippingMethod = res.data.value[0].ValidValuesMD.find(x => x.Value === this.returnRequest.U_ShippingMethod);
        }).catch(err => {
          console.error(err); 
        });

        axios.get(`api/user_fields/FreightPayment`)
        .then(res => {
          this.freightPayment = res.data.value[0].ValidValuesMD.find(x => x.Value === this.returnRequest.U_FreightPayment);
        }).catch(err => {
          console.error(err); 
        });
        
        }).catch(err => {
          console.error(err);
        });
    },
    preventExit(event) {
      if(this.creating){
        event.preventDefault();
        event.returnValue = "Nota de Crédito en proceso. ¿Estás seguro que deseas salir de la página?";
        const exitProcess = {
          DocNum: this.returnRequest.DocNum,
          DocEntry: this.returnRequest.DocEntry,
          DocType: "ReturnRequest",
          Email: this.user.email,
          ExitType: "LeavePage"
        }
        posthog.capture('ExitProcess', exitProcess);
      }
    },
    loadInvoices(U_WebRefObj){
      let endpoint = `${this.HANA_URL}/api/hana/basic_general_query`;

      let query = {
        select: `"DocEntry","DocNum","DocDate","CardCode","CardName","NumAtCard","U_Delivered","U_DeliveryDate","U_WebXML","DocTotal","PaidSum","DocTotalFC","PaidSumFc","DocCur"`,
        table: "OINV",
        where: `WHERE "CardCode" = '${this.returnRequest.CardCode}' AND "DocStatus" = 'O'`
      };
          
      if(U_WebRefObj === 'FAT'){
        query.table = "ODPI";
        this.selInvType = this.invTypes[1];
      } else {
        this.selInvType = this.invTypes[0];
      }

      this.invoices = null;
      axios.post(endpoint, query)
        .then(res => {
          this.invoices = res.data;
          if(this.returnRequest.U_WebRefDocNum){
            this.errorReportIds = [];
            this.selInvoices = this.returnRequest.U_WebRefDocNum
              .split(",")
              .map(docNum => {
                return this.invoices.find(y => y.DocNum === parseInt(docNum));
              })
              .filter(x => x);
            const requests = this.selInvoices.map(invoice => {
              return axios
              .post(`api/fiscal/electronic_docs`, { document_type: this.selInvType.elTypeId, doc_entry: invoice.DocEntry })
            });
            axios
            .all(requests)
            .then(axios.spread((...responses) => {
              const repIds = [];
              responses.forEach((res) => {
                if (res.data[0].U_TS_ReportID) {
                  repIds.push(res.data[0].U_TS_ReportID);
                } else {
                  this.$swal(`Factura #${res.data[0].DocNum}`, 'Esta factura no ha sido timbrada.', 'warning');
                  const index = this.selInvoices.findIndex(x => {
                    return x.DocNum === res.data[0].DocNum;
                  });
                  this.selInvoices.splice(index, 1);
                  this.errorReportIds.push(res.data[0].DocNum);
                }
              });
              this.reportIds = repIds;
            })).catch(err => {
              console.error(err);
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
  created() {
    this.user = getAuth().currentUser;
    if(this.production){
      if(this.user.email === 'darinkahernandez@canplast.com.mx' || this.user.email === 'dannasandoval@canplast.com.mx'){
        this.approvalEmails = [
          'ofelialujan@canplast.com.mx',
          'lizethflores@canplast.com.mx'
        ];
      } else {
        this.approvalEmails = [
          'salvadorbarbosa@canplast.com.mx',
          'ofelialujan@canplast.com.mx',
          'federicoflores@canplast.com.mx'
        ];
      }
    } else {
      this.approvalEmails = [
        this.user.email // Comment or uncomment this line to test the approval process
        // commented: you are a requester
        // uncommented: you are an approver
      ];
    }

    this.loadReturnRequest();

    axios.get(`/api/regimen_fiscal`)
      .then(res => {
        this.regimenes = res.data;
      }).catch(err => {
        console.error(err);
      });

    axios.get(`/api/sales_persons`)
      .then((res) => {
        this.salesPersonOptions = res.data.value;
      }).catch((err) => {
        console.error(err);
      });
  },
  computed: {
    validation() {
      const { FederalTaxID, U_TS_RegFiscal, U_TS_UsoSN, SalesPersonCode } = this.customer;
      let complete = {
        "No tienes permiso para crear la Nota de Crédito": this.credNotePermission,
        "Cliente": this.customer,
        "Razón de devolución": this.selReasonReturn,
        "Vía de Pago": this.selPaymentMethod,
        "Tipo de referencia": this.refTypeSelected,
        "RFC": FederalTaxID,
        "Régimen Fiscal": U_TS_RegFiscal,
        "Uso CFDI": U_TS_UsoSN,
        "Vendedor": SalesPersonCode,
        "Código Postal": this.zipCode,
        "Factura(s)": this.reportIds.length && this.errorReportIds.length === 0,
      };
      if(!['P', null, 'R'].includes(this.returnRequest.U_ApprovalStatus)){
        const completeApproved = {
          "Pedimentos": !this.docLines.some(x => 
            x.Items.U_Import === 'Y' && 
            !x.U_PedimentNum && 
            !x['ReturnRequest/DocumentLines'].U_PedimentNum
          ),
        }
        complete = {...complete, ...completeApproved};
      }

      return {
        valid: Object.values(complete).every((x) => x),
        missing: Object.keys(complete).filter((x) => !complete[x]),
      };
    },
    popoverData() {
      if(this.returnRequest.U_ApprovalStatus === 'RV'){
        return 'Esta solicitud se encuentra en revisión';
      }

      if (this.validation.missing.length > 0) {
        return {
          title: "<small><b>Verifica los siguientes campos:</b></small>",
          content: `<ul><li>${this.validation.missing.join("<li>")}</ul>`,
          placement: "righttop",
        };
      } else {
        return null;
      }
    },
  },
  mounted(){
    window.addEventListener('beforeunload', this.preventExit);
  },
  beforeDestroy(){
    window.removeEventListener('beforeunload', this.preventExit);
  },
  beforeRouteLeave(to, from, next){
    if(this.creating){
      this.$swal({
        title: "Nota de Crédito en proceso",
        text: "¿Estás seguro que deseas salir de la página? Si sales, podrías afectar el proceso de creación.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Salir de todos modos",
        cancelButtonText: "Permanecer en la página",
      })
      .then((result) => {
        if (result.isConfirmed) {
          const exitProcess = {
            DocNum: this.returnRequest.DocNum,
            DocEntry: this.returnRequest.DocEntry,
            DocType: "ReturnRequest",
            Email: this.user.email,
            ExitType: "ChangeRoute"
          }
          posthog.capture('ExitProcess', exitProcess);
          next();
        }
      });
    } else {
      next();
    }
  }

}

</script>

<style scoped>
.custom-side-cards{
  min-width: 100%; 
  width: 100%;
}
@media (min-width:1200px) { 
  .custom-side-cards {
    min-width: 360px; 
    width: 360px;  
  }
}
</style>